import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CircularProgressbar } from "react-circular-progressbar";
import { useSelector } from "react-redux";
import { PieChart } from "react-minimal-pie-chart";
import { motion } from "framer-motion";
import AXIOS from "../../../config/axios";
import { formattedDate } from "./../../../utils/formulas";
import "react-circular-progressbar/dist/styles.css";
import "sweetalert2/dist/sweetalert2.min.css";
import styles from "./style.module.css";
const streaming_url = process.env.REACT_APP_STREAMIN_SOCKET_URL;
const Dashboard = () => {
  const isAuthenticated = useSelector((state) => state.user);
  const [dashCount, setDashCount] = useState([]);
  const [pickups, setPickups] = useState([]);
  const [data, setData] = useState({});
  const [chartData, setChartData] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [streamUrl, setStreamUrl] = useState("");

  const divClassName = isActive ? "sidebar active" : "sidebar";
  useEffect(() => {
    fetchDataFromAPI();
    getPickups();
  }, []);
  useEffect(() => {
    const updatedChartData = [
      { title: "New Pickups", value: data.newPickup, color: "#E38627" },
      {
        title: "Complete Pickups",
        value: data.completePickup,
        color: "#3e98c7",
      },
      { title: "Cancel Pickups", value: data.cancelPickup, color: "#C13C37" },
    ];
    setChartData(updatedChartData);
  }, [data]);
  // Function to load stream on a specific canvas
  const loadStreamOnCanvas = (canvasId, streamUrl) => {
    const canvas = document.getElementById(canvasId);
    const encoded = encodeURIComponent(streamUrl);
    if (canvas && window.loadPlayer) {
      try {
        /* eslint-disable no-undef */
        loadPlayer({
          url: `${streaming_url}/stream/pickup/fisheye/${encoded}`,
          canvas: canvas,
        });
        /* eslint-enable no-undef */
        console.log(`Stream loaded successfully on ${canvasId}`);
      } catch (error) {
        console.error(`Error loading stream on ${canvasId}:`, error);
      }
    } else {
      console.error(`Canvas ${canvasId} not found or loadPlayer not available`);
    }
  };

  useEffect(() => {
    if (streamUrl) {
      const script = document.createElement("script");
      script.src =
        "https://cdn.jsdelivr.net/npm/rtsp-relay@1.7.0/browser/index.js";
      script.async = true;
      script.onload = () => {
        // Load stream on the main canvas
        loadStreamOnCanvas("canvas", streamUrl);
      };
      document.head.appendChild(script);
      return () => {
        // Clean up the script element if the component unmounts
        document.head.removeChild(script);
      };
    }
  }, [streamUrl]);

  const fetchDataFromAPI = async () => {
    try {
      AXIOS.get("auth/dashboard/locker/chart")
        .then((res) => {
          setData(res.data);
          // if(res?.data?.streamUrl){
          setStreamUrl(
            res?.data?.streamUrl ||
              ""
          );
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      return { available: 0, occupied: 0, inactive: 0 };
    }
  };
  const dashboardCounts = async () => {
    try {
      AXIOS.get("auth/dashboard/count")
        .then((res) => {
          setDashCount(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error(error);
    }
  };
  const getPickups = async () => {
    try {
      AXIOS.get("/pickups/list/dashboard")
        .then((res) => {
          setPickups(res.data.pickups);
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      return { available: 0, occupied: 0, inactive: 0 };
    }
  };
  // Function to toggle the active state
  const toggleActive = () => {
    setIsActive(!isActive);
  };
  // Define the CSS classes based on the isActive state
  return (
    <div className={styles.body_wrap}>
      {/* <div className='mb-4 fw-medium fst-italic fs-6 row col-lg-5'>
        <span className='col text-capitalize'> Hello {isAuthenticated?.name} </span>
        || <span className="text-white mx-3 text-center rounded bg-success col text-capitalize ">{isAuthenticated?.role} </span>
        || <span className='col'><i className="fa fa-map-marker" /> Invid Technology</span>
      </div> */}

      <div className="row mb-3">
        <div className="col-lg-3">
          <div className={`card rounded-4 border-0 shadow`}>
            <div className="card-body">
              <div className="row">
                <div className="col-8">
                  <p className={styles.dash_count_title}>Occupied Lockers</p>
                  <p className={styles.dash_count}>{data.occupied}</p>
                </div>
                <div className="col-4 text-end">
                  <CircularProgressbar
                    value={data.occupied}
                    text={`${((data.occupied / data.total) * 100).toFixed(2)}%`}
                    maxValue={data.total}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className={`card rounded-4 border-0 shadow`}>
            <div className="card-body">
              <div className="row">
                <div className="col-8">
                  <p className={styles.dash_count_title}>Available Lockers</p>
                  <p className={styles.dash_count}>{data.available}</p>
                </div>
                <div className="col-4 text-end">
                  <CircularProgressbar
                    value={data.available}
                    text={`${((data.available / data.total) * 100).toFixed(
                      2
                    )}%`}
                    maxValue={data.total}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className={`card rounded-4 border-0 shadow`}>
            <div className="card-body">
              <div className="row">
                <div className="col-8">
                  <p className={styles.dash_count_title}>Inactive Lockers</p>
                  <p className={styles.dash_count}>{data.inactive}</p>
                </div>
                <div className="col-4 text-end">
                  <CircularProgressbar
                    value={data.inactive}
                    text={`${data.inactive * data.total}%`}
                    maxValue={data.total}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className={`card rounded-4 border-0 shadow`}>
            <div className="card-body">
              <div className="row">
                <div className="col-8">
                  <p className={styles.dash_count_title}>Total Lockers</p>
                  <p className={styles.dash_count}>{data.total}</p>
                </div>
                <div className="col-4 text-end">
                  <CircularProgressbar
                    value={data.total}
                    text={`100%`}
                    maxValue={data.total}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="row mb-3"
        style={{
          display: `${
            (isAuthenticated?.role.toLowerCase() === "admin" &&
              isAuthenticated?.site_id === "684a7609d99c33ed3a3d58de") ||
            isAuthenticated?.role.toLowerCase() === "superadmin"
              ? "block"
              : "none"
          }`,
        }}
      >
        <div className="col-lg-4">
          <div className="card rounded-4 border-0 shadow">
            <div className="card-body p-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="mb-0">Live Stream</h6>

                <a
                  href="http://47.21.194.132:4006"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <p className="mb-0">Playback</p>{" "}
                </a>
              </div>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  position: "relative",
                  overflow: "hidden",
                  objectFit: "contain",
                  height: "120px",
                  backgroundColor: "#f8f9fa",
                  borderRadius: "8px",
                }}
              >
                <canvas
                  id="canvas"
                  height="120"
                  width="200"
                  style={{
                    width: "200px",
                    height: "120px",
                    position: "static",
                    zIndex: "0",
                    // display: `${
                    //   (isAuthenticated?.role.toLowerCase() === "admin" &&
                    //     isAuthenticated?.site_id ===
                    //       "684a7609d99c33ed3a3d58de") ||
                    //   isAuthenticated?.role.toLowerCase() === "superadmin"
                    //     ? "block"
                    //     : "none"
                    // }`,
                  }}
                ></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-3 ">
        <div className="col-12">
          <h6 className="text-end">
            {" "}
            Your Pickup Orders |{" "}
            <Link to="/pickup/list" className="btn btn-outline-primary">
              View All
            </Link>
          </h6>
          <div className="table-wrap">
            <div className="row">
              <div className="col-12">
                <div className={styles.card_box}>
                  <div className={styles.tables_wrap}>
                    <div className="table-responsive">
                      <table className="table align-middle">
                        <thead>
                          <tr>
                            <th>ORDER#</th>
                            <th>PICKUP CODE</th>
                            <th>SITE</th>
                            <th>BOOKED BY</th>
                            <th>CUSTOMER</th>
                            <th>ORDER DATE</th>
                            <th>STATUS</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {pickups.length > 0 &&
                            pickups.map((item, i) => (
                              <motion.tr
                                key={item._id}
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ duration: 1.2, delay: i * 0.1 }}
                              >
                                <td>{item.order_number}</td>
                                <td>{item.pickup_code}</td>
                                <td>
                                  <i className="fa fa-map-marker"></i>{" "}
                                  {item.site}
                                </td>
                                <td>
                                  <h6
                                    className="mb-0 m-0 fs-14 "
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: "200",
                                    }}
                                  >
                                    {item.user.name}
                                    <br />
                                    {item.user.email}
                                  </h6>
                                </td>
                                <td>
                                  <h6
                                    className="mb-0 m-0 fs-14 "
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: "200",
                                    }}
                                  >
                                    {item.customer && item.customer !== "" && (
                                      <div>
                                        {item.customer.name} <br />
                                      </div>
                                    )}
                                    {item.customer_email}
                                  </h6>
                                </td>
                                <td>{formattedDate(item.createdAt)}</td>
                                <td>
                                  {(() => {
                                    switch (item.status) {
                                      case "new":
                                        return (
                                          <span
                                            className="badge bg-primary"
                                            style={{ fontSize: "12px" }}
                                          >
                                            New
                                          </span>
                                        );
                                      case "completed":
                                        return (
                                          <>
                                            <span
                                              className="badge bg-success"
                                              style={{ fontSize: "12px" }}
                                            >
                                              Completed
                                            </span>
                                            <br />
                                            <span>
                                              Pickup time:{" "}
                                              {formattedDate(item.updatedAt)}
                                            </span>
                                          </>
                                        );
                                      case "cancelled":
                                        return (
                                          <span
                                            className="badge bg-danger"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Cancelled
                                          </span>
                                        );
                                      case "refunded":
                                        return (
                                          <span
                                            className="badge bg-danger"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Refunded
                                          </span>
                                        );
                                      case "occupied":
                                        return (
                                          <span
                                            className="badge bg-warning"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Occupied
                                          </span>
                                        );
                                      default:
                                        return null;
                                    }
                                  })()}
                                </td>
                                <td className="text-end">
                                  <Link
                                    to={`/pickup/detail/${item._id} `}
                                    className="btn btn-outline-primary"
                                  >
                                    View
                                  </Link>
                                </td>
                              </motion.tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 mt-4">
          <div className={`card ${styles.locker_chart_box}`}>
            <div className="card-body">
              <h4>Pickups Statistics</h4>
              <div className="row mt-4">
                <div
                  className="col-lg-8 fst-italic "
                  style={{ fontSize: "13px" }}
                >
                  <p className="m-2 p-0">
                    <span style={{ color: "#0D6EFD" }}>
                      New : {data.newPickup}
                    </span>
                  </p>
                  <p className="m-2 p-0">
                    <span style={{ color: "#E38627" }}>
                      Completed : {data.completePickup}
                    </span>{" "}
                  </p>
                  <p className="m-2 p-0">
                    <span style={{ color: "#DC3545" }}>
                      Cancelled : {data.cancelPickup}
                    </span>{" "}
                  </p>
                </div>
                <div className="col-lg-4 text-end">
                  {chartData && <PieChart data={chartData} />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dashboard;
